import { Image, Flag as UIFlag } from 'semantic-ui-react';
import styled from 'styled-components';

interface IFlagImageProps {
  width: number;
  height: number;
}

const FlagImage = styled(Image)<IFlagImageProps>`
  display: inline !important;
  margin-right: 7px;
  min-width: ${({ width }) => width}px !important;
  min-height: ${({ height }) => height}px !important;
  max-width: ${({ width }) => width}px !important;
  max-height: ${({ height }) => height}px !important;
`;

interface IDropdownOption {
  name?: string;
  value?: string;
  flag?: string;
  [key: string]: any;
}

interface IDropdownOptionWithFlag extends IDropdownOption {
  image: { src: string };
  flag: null;
}

export const dropdownOptionsIncludeFlag = (
  arr: IDropdownOption[] = [],
): IDropdownOptionWithFlag[] =>
  arr.map(opt => {
    const flagSource =
      flagImages?.[opt.name?.toUpperCase?.()] ||
      flagImages?.[opt.value?.toUpperCase?.()] ||
      flagImages?.[opt.flag?.toUpperCase?.()];
    return {
      ...opt,
      image: { src: flagSource || flagImages.WW },
      flag: null,
    };
  });

interface IFlagProps {
  width?: number;
  height?: number;
  name?: string;
  title?: string;
  className?: string;
}

export function Flag({
  width = 20,
  height = 15,
  name,
  title,
  className = '',
}: IFlagProps): JSX.Element {
  return flagImages[name?.toUpperCase() || ''] ? (
    <FlagImage
      width={width}
      height={height}
      className={className}
      src={flagImages[name?.toUpperCase() || '']}
      title={title}
    />
  ) : (
    <UIFlag name={name?.toLowerCase() as any} className={className} />
  );
}

export const flagImages: Record<string, string> = {
  AD: 'https://cdn.skupreme.com/public/flags/AD.png',
  AE: 'https://cdn.skupreme.com/public/flags/AE.png',
  AF: 'https://cdn.skupreme.com/public/flags/AF.png',
  AG: 'https://cdn.skupreme.com/public/flags/AG.png',
  AI: 'https://cdn.skupreme.com/public/flags/AI.png',
  AM: 'https://cdn.skupreme.com/public/flags/AM.png',
  AL: 'https://cdn.skupreme.com/public/flags/AL.png',
  AN: 'https://cdn.skupreme.com/public/flags/AN.png',
  AU: 'https://cdn.skupreme.com/public/flags/AU.png',
  AO: 'https://cdn.skupreme.com/public/flags/AO.png',
  AR: 'https://cdn.skupreme.com/public/flags/AR.png',
  AT: 'https://cdn.skupreme.com/public/flags/AT.png',
  AW: 'https://cdn.skupreme.com/public/flags/AW.png',
  AX: 'https://cdn.skupreme.com/public/flags/AX.png',
  AZ: 'https://cdn.skupreme.com/public/flags/AZ.png',
  BA: 'https://cdn.skupreme.com/public/flags/BA.png',
  BB: 'https://cdn.skupreme.com/public/flags/BB.png',
  BD: 'https://cdn.skupreme.com/public/flags/BD.png',
  BE: 'https://cdn.skupreme.com/public/flags/BE.png',
  BF: 'https://cdn.skupreme.com/public/flags/BF.png',
  BG: 'https://cdn.skupreme.com/public/flags/BG.png',
  BH: 'https://cdn.skupreme.com/public/flags/BH.png',
  BI: 'https://cdn.skupreme.com/public/flags/BI.png',
  BJ: 'https://cdn.skupreme.com/public/flags/BJ.png',
  BM: 'https://cdn.skupreme.com/public/flags/BM.png',
  BN: 'https://cdn.skupreme.com/public/flags/BN.png',
  BO: 'https://cdn.skupreme.com/public/flags/BO.png',
  BR: 'https://cdn.skupreme.com/public/flags/BR.png',
  BS: 'https://cdn.skupreme.com/public/flags/BS.png',
  BT: 'https://cdn.skupreme.com/public/flags/BT.png',
  BW: 'https://cdn.skupreme.com/public/flags/BW.png',
  BY: 'https://cdn.skupreme.com/public/flags/BY.png',
  BZ: 'https://cdn.skupreme.com/public/flags/BZ.png',
  CAF: 'https://cdn.skupreme.com/public/flags/CAF.png',
  CA: 'https://cdn.skupreme.com/public/flags/CA.png',
  CD: 'https://cdn.skupreme.com/public/flags/CD.png',
  CF: 'https://cdn.skupreme.com/public/flags/CF.png',
  CG: 'https://cdn.skupreme.com/public/flags/CG.png',
  CH: 'https://cdn.skupreme.com/public/flags/CH.png',
  CI: 'https://cdn.skupreme.com/public/flags/CI.png',
  CL: 'https://cdn.skupreme.com/public/flags/CL.png',
  CM: 'https://cdn.skupreme.com/public/flags/CM.png',
  CN: 'https://cdn.skupreme.com/public/flags/CN.png',
  CO: 'https://cdn.skupreme.com/public/flags/CO.png',
  COC: 'https://cdn.skupreme.com/public/flags/COC.png',
  CR: 'https://cdn.skupreme.com/public/flags/CR.png',
  CSA: 'https://cdn.skupreme.com/public/flags/CSA.png',
  CU: 'https://cdn.skupreme.com/public/flags/CU.png',
  CV: 'https://cdn.skupreme.com/public/flags/CV.png',
  CY: 'https://cdn.skupreme.com/public/flags/CY.png',
  CZ: 'https://cdn.skupreme.com/public/flags/CZ.png',
  DE: 'https://cdn.skupreme.com/public/flags/DE.png',
  DJ: 'https://cdn.skupreme.com/public/flags/DJ.png',
  DK: 'https://cdn.skupreme.com/public/flags/DK.png',
  DM: 'https://cdn.skupreme.com/public/flags/DM.png',
  DO: 'https://cdn.skupreme.com/public/flags/DO.png',
  DZ: 'https://cdn.skupreme.com/public/flags/DZ.png',
  EC: 'https://cdn.skupreme.com/public/flags/EC.png',
  EE: 'https://cdn.skupreme.com/public/flags/EE.png',
  EG: 'https://cdn.skupreme.com/public/flags/EG.png',
  ER: 'https://cdn.skupreme.com/public/flags/ER.png',
  ES: 'https://cdn.skupreme.com/public/flags/ES.png',
  ET: 'https://cdn.skupreme.com/public/flags/ET.png',
  EU: 'https://cdn.skupreme.com/public/flags/EU.png',
  FI: 'https://cdn.skupreme.com/public/flags/FI.png',
  FJ: 'https://cdn.skupreme.com/public/flags/FJ.png',
  FK: 'https://cdn.skupreme.com/public/flags/FK.png',
  FM: 'https://cdn.skupreme.com/public/flags/FM.png',
  FR: 'https://cdn.skupreme.com/public/flags/FR.png',
  GA: 'https://cdn.skupreme.com/public/flags/GA.png',
  GB: 'https://cdn.skupreme.com/public/flags/GB.png',
  GD: 'https://cdn.skupreme.com/public/flags/GD.png',
  GE: 'https://cdn.skupreme.com/public/flags/GE.png',
  GG: 'https://cdn.skupreme.com/public/flags/GG.png',
  GH: 'https://cdn.skupreme.com/public/flags/GH.png',
  GI: 'https://cdn.skupreme.com/public/flags/GI.png',
  GM: 'https://cdn.skupreme.com/public/flags/GM.png',
  GN: 'https://cdn.skupreme.com/public/flags/GN.png',
  GP: 'https://cdn.skupreme.com/public/flags/GP.png',
  GQ: 'https://cdn.skupreme.com/public/flags/GQ.png',
  GR: 'https://cdn.skupreme.com/public/flags/GR.png',
  GT: 'https://cdn.skupreme.com/public/flags/GT.png',
  GW: 'https://cdn.skupreme.com/public/flags/GW.png',
  GY: 'https://cdn.skupreme.com/public/flags/GY.png',
  HK: 'https://cdn.skupreme.com/public/flags/HK.png',
  HN: 'https://cdn.skupreme.com/public/flags/HN.png',
  HR: 'https://cdn.skupreme.com/public/flags/HR.png',
  HT: 'https://cdn.skupreme.com/public/flags/HT.png',
  HU: 'https://cdn.skupreme.com/public/flags/HU.png',
  ID: 'https://cdn.skupreme.com/public/flags/ID.png',
  IE: 'https://cdn.skupreme.com/public/flags/IE.png',
  IL: 'https://cdn.skupreme.com/public/flags/IL.png',
  IM: 'https://cdn.skupreme.com/public/flags/IM.png',
  IN: 'https://cdn.skupreme.com/public/flags/IN.png',
  IR: 'https://cdn.skupreme.com/public/flags/IR.png',
  IS: 'https://cdn.skupreme.com/public/flags/IS.png',
  IT: 'https://cdn.skupreme.com/public/flags/IT.png',
  JE: 'https://cdn.skupreme.com/public/flags/JE.png',
  JM: 'https://cdn.skupreme.com/public/flags/JM.png',
  JO: 'https://cdn.skupreme.com/public/flags/JO.png',
  JP: 'https://cdn.skupreme.com/public/flags/JP.png',
  KE: 'https://cdn.skupreme.com/public/flags/KE.png',
  KG: 'https://cdn.skupreme.com/public/flags/KG.png',
  KH: 'https://cdn.skupreme.com/public/flags/KH.png',
  KM: 'https://cdn.skupreme.com/public/flags/KM.png',
  KN: 'https://cdn.skupreme.com/public/flags/KN.png',
  KP: 'https://cdn.skupreme.com/public/flags/KP.png',
  KR: 'https://cdn.skupreme.com/public/flags/KR.png',
  KW: 'https://cdn.skupreme.com/public/flags/KW.png',
  KY: 'https://cdn.skupreme.com/public/flags/KY.png',
  KZ: 'https://cdn.skupreme.com/public/flags/KZ.png',
  LA: 'https://cdn.skupreme.com/public/flags/LA.png',
  LB: 'https://cdn.skupreme.com/public/flags/LB.png',
  LC: 'https://cdn.skupreme.com/public/flags/LC.png',
  LI: 'https://cdn.skupreme.com/public/flags/LI.png',
  LK: 'https://cdn.skupreme.com/public/flags/LK.png',
  LR: 'https://cdn.skupreme.com/public/flags/LR.png',
  LS: 'https://cdn.skupreme.com/public/flags/LS.png',
  LT: 'https://cdn.skupreme.com/public/flags/LT.png',
  LU: 'https://cdn.skupreme.com/public/flags/LU.png',
  LV: 'https://cdn.skupreme.com/public/flags/LV.png',
  LY: 'https://cdn.skupreme.com/public/flags/LY.png',
  MA: 'https://cdn.skupreme.com/public/flags/MA.png',
  MC: 'https://cdn.skupreme.com/public/flags/MC.png',
  MD: 'https://cdn.skupreme.com/public/flags/MD.png',
  ME: 'https://cdn.skupreme.com/public/flags/ME.png',
  MG: 'https://cdn.skupreme.com/public/flags/MG.png',
  MK: 'https://cdn.skupreme.com/public/flags/MK.png',
  ML: 'https://cdn.skupreme.com/public/flags/ML.png',
  MM: 'https://cdn.skupreme.com/public/flags/MM.png',
  MN: 'https://cdn.skupreme.com/public/flags/MN.png',
  MO: 'https://cdn.skupreme.com/public/flags/MO.png',
  MR: 'https://cdn.skupreme.com/public/flags/MR.png',
  MS: 'https://cdn.skupreme.com/public/flags/MS.png',
  MT: 'https://cdn.skupreme.com/public/flags/MT.png',
  MU: 'https://cdn.skupreme.com/public/flags/MU.png',
  MV: 'https://cdn.skupreme.com/public/flags/MV.png',
  MW: 'https://cdn.skupreme.com/public/flags/MW.png',
  MX: 'https://cdn.skupreme.com/public/flags/MX.png',
  MY: 'https://cdn.skupreme.com/public/flags/MY.png',
  MZ: 'https://cdn.skupreme.com/public/flags/MZ.png',
  NA: 'https://cdn.skupreme.com/public/flags/NA.png',
  NE: 'https://cdn.skupreme.com/public/flags/NE.png',
  NG: 'https://cdn.skupreme.com/public/flags/NG.png',
  NI: 'https://cdn.skupreme.com/public/flags/NI.png',
  NL: 'https://cdn.skupreme.com/public/flags/NL.png',
  NO: 'https://cdn.skupreme.com/public/flags/NO.png',
  NP: 'https://cdn.skupreme.com/public/flags/NP.png',
  NZ: 'https://cdn.skupreme.com/public/flags/NZ.png',
  OM: 'https://cdn.skupreme.com/public/flags/OM.png',
  PA: 'https://cdn.skupreme.com/public/flags/PA.png',
  PE: 'https://cdn.skupreme.com/public/flags/PE.png',
  PF: 'https://cdn.skupreme.com/public/flags/PF.png',
  PG: 'https://cdn.skupreme.com/public/flags/PG.png',
  PH: 'https://cdn.skupreme.com/public/flags/PH.png',
  PK: 'https://cdn.skupreme.com/public/flags/PK.png',
  PL: 'https://cdn.skupreme.com/public/flags/PL.png',
  PR: 'https://cdn.skupreme.com/public/flags/PR.png',
  PT: 'https://cdn.skupreme.com/public/flags/PT.png',
  PW: 'https://cdn.skupreme.com/public/flags/PW.png',
  PY: 'https://cdn.skupreme.com/public/flags/PY.png',
  QA: 'https://cdn.skupreme.com/public/flags/QA.png',
  RO: 'https://cdn.skupreme.com/public/flags/RO.png',
  RS: 'https://cdn.skupreme.com/public/flags/RS.png',
  RU: 'https://cdn.skupreme.com/public/flags/RU.png',
  RW: 'https://cdn.skupreme.com/public/flags/RW.png',
  SA: 'https://cdn.skupreme.com/public/flags/SA.png',
  SB: 'https://cdn.skupreme.com/public/flags/SB.png',
  SC: 'https://cdn.skupreme.com/public/flags/SC.png',
  SD: 'https://cdn.skupreme.com/public/flags/SD.png',
  SE: 'https://cdn.skupreme.com/public/flags/SE.png',
  SG: 'https://cdn.skupreme.com/public/flags/SG.png',
  SH: 'https://cdn.skupreme.com/public/flags/SH.png',
  SI: 'https://cdn.skupreme.com/public/flags/SI.png',
  SK: 'https://cdn.skupreme.com/public/flags/SK.png',
  SL: 'https://cdn.skupreme.com/public/flags/SL.png',
  SM: 'https://cdn.skupreme.com/public/flags/SM.png',
  SN: 'https://cdn.skupreme.com/public/flags/SN.png',
  SO: 'https://cdn.skupreme.com/public/flags/SO.png',
  SR: 'https://cdn.skupreme.com/public/flags/SR.png',
  ST: 'https://cdn.skupreme.com/public/flags/ST.png',
  SV: 'https://cdn.skupreme.com/public/flags/SV.png',
  SY: 'https://cdn.skupreme.com/public/flags/SY.png',
  SZ: 'https://cdn.skupreme.com/public/flags/SZ.png',
  TC: 'https://cdn.skupreme.com/public/flags/TC.png',
  TD: 'https://cdn.skupreme.com/public/flags/TD.png',
  TG: 'https://cdn.skupreme.com/public/flags/TG.png',
  TH: 'https://cdn.skupreme.com/public/flags/TH.png',
  TJ: 'https://cdn.skupreme.com/public/flags/TJ.png',
  TL: 'https://cdn.skupreme.com/public/flags/TL.png',
  TM: 'https://cdn.skupreme.com/public/flags/TM.png',
  TN: 'https://cdn.skupreme.com/public/flags/TN.png',
  TO: 'https://cdn.skupreme.com/public/flags/TO.png',
  TQ: 'https://cdn.skupreme.com/public/flags/TQ.png',
  TR: 'https://cdn.skupreme.com/public/flags/TR.png',
  TT: 'https://cdn.skupreme.com/public/flags/TT.png',
  TW: 'https://cdn.skupreme.com/public/flags/TW.png',
  TZ: 'https://cdn.skupreme.com/public/flags/TZ.png',
  UA: 'https://cdn.skupreme.com/public/flags/UA.png',
  US: 'https://cdn.skupreme.com/public/flags/USA.png',
  UG: 'https://cdn.skupreme.com/public/flags/UG.png',
  UZ: 'https://cdn.skupreme.com/public/flags/UZ.png',
  VC: 'https://cdn.skupreme.com/public/flags/VC.png',
  VE: 'https://cdn.skupreme.com/public/flags/VE.png',
  VG: 'https://cdn.skupreme.com/public/flags/VG.png',
  VN: 'https://cdn.skupreme.com/public/flags/VN.png',
  VU: 'https://cdn.skupreme.com/public/flags/VU.png',
  WS: 'https://cdn.skupreme.com/public/flags/WS.png',
  WW: 'https://cdn.skupreme.com/public/flags/WW.png',
  YE: 'https://cdn.skupreme.com/public/flags/YE.png',
  YU: 'https://cdn.skupreme.com/public/flags/YU.png',
  ZA: 'https://cdn.skupreme.com/public/flags/ZA.png',
  ZM: 'https://cdn.skupreme.com/public/flags/ZM.png',
  ZW: 'https://cdn.skupreme.com/public/flags/ZW.png',
};
